export default __webpack_public_path__ + "92712d430a72e77c464af46baf3abe8b.webp";